export default __webpack_public_path__ + "static/media/consultant.6facb625.svg";